import { isString } from "lodash";

/**
 * 移除字符串中的标签
 * @param html
 * @returns {string}
 */
export const cleanHtmlTag = (html) => html.replace(/<[^>]*>/g, "");

/**
 * 获取可能的拼音序列,输入的非中文字符会自动忽略
 * 如 input='长空'，return=[['chang', 'kong'], ['zhang', 'kong']]
 * @param {string} input
 * @returns {Promise<[string][]>}
 */
export const getPossiblePinYin = async (input) => {
  const pinyinjs = (await import("thepinyin.js")).default;
  const pinyins = pinyinjs.py(input, pinyinjs.NOMARK);
  const availStrs = [];
  let count = 0;
  const makeAvailStrs = (pys, result) => {
    if (!pys?.length || count >= 5) return;

    if (!result) {
      result = [];
      availStrs.push(result);
    }

    const [current, ...rest] = pys;

    if (Array.isArray(current)) {
      const copy = Array.from(result);
      for (let i = 0; i < current.length; ++i) {
        let tr = i ? Array.from(copy) : result;
        if (i) {
          availStrs.push(tr);
        }
        tr.push(current[i]);
        makeAvailStrs(rest, tr);
      }
    } else {
      result.push(current);
      makeAvailStrs(rest, result);
    }

    count++;
  };
  makeAvailStrs(pinyins);
  return availStrs;
};

// 立冬❄️ -> 立冬  (移除字符串中的 emoji 符号)
export const removeEmoji = (str) => {
  if (isString(str)) {
    // 该正则表达式匹配 emoji 符号
    // 统一码所有区段 https://www.fuhaoku.net/blocks
    const emojiRegex =
      /[\uD83C-\uDBFF\uDC00-\uDFFF\u2600-\u26FF\u2700-\u27BF\u23E9-\u23FA\u231A\u231B\u2B55\u2B50\u2B1B\u2B1C\uFE00-\uFE0F]/g;

    // 将字符串中所有的 emoji 符号替换成空字符串
    return str.replace(emojiRegex, "");
  }

  return str;
};
